export default "__VITE_ASSET__DVQxi_ou__"